import { render, staticRenderFns } from "./svg-gift-wrap.vue?vue&type=template&id=0036910a&"
import script from "./svg-gift-wrap.vue?vue&type=script&lang=js&"
export * from "./svg-gift-wrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports